/**
 * Sdílené dotazy karet lidí. Hooky volají jen stránky (`DestinationTeamsPage`,
 * `DestinationTeamEditPage`); modul na úrovni modulu nic nevolá.
 */
import { useQuery } from "@tanstack/react-query";
import { api, type ApiResponse } from "@/api/client";
import type { AdminTeamListItem, Guide } from "@ckgo2/shared/types";

/**
 * Klíč seznamu karet. Je to `listKey` editoru (`useEditPage` po uložení invaliduje
 * `[listKey]`) i klíč mazání v seznamu, takže seznam i nápověda editoru „U destinace dále"
 * sdílejí jednu keš a po uložení se obnoví.
 */
export const ADMIN_TEAM_LIST_KEY = ["destination-teams"] as const;

/** Všechny karty včetně neaktivních, s vazbami (`destinationLinks`, první = primární). */
export function useAdminTeamList() {
  return useQuery({
    queryKey: ADMIN_TEAM_LIST_KEY,
    queryFn: () => api.get<ApiResponse<AdminTeamListItem[]>>("/api/admin/destination-teams"),
  });
}

/**
 * Klíč a cesta jsou doslova dotaz `DepartureDetailPage` (sdílená keš nad týmiž daty). Admin
 * seznam, ne veřejný `/api/guides`: ten vrací jen aktivní průvodce a uložený neaktivní profil
 * by v nabídce chyběl. Klíč `["guides"]` patří veřejnému seznamu (`DestinationEditPage`).
 */
export const GUIDE_LOOKUP_KEY = ["guides", "lookup"] as const;

export type GuideLookupItem = Pick<Guide, "id" | "name" | "isActive">;

export function useGuideLookup() {
  return useQuery({
    queryKey: GUIDE_LOOKUP_KEY,
    queryFn: () => api.get<ApiResponse<GuideLookupItem[]>>("/api/admin/guides?limit=100"),
  });
}
